import {
    ADVERTISER_REPORT,
    AD_COVERAGE,
    GROSS_REVENUE,
    PUBLISHER_REVENUE,
    DATE,
    TAG_ID,
    CHANNEL,
    RULE_ID,
    GEO,
    TOTAL_SEARCHES,
    MONETIZED_SEARCHES,
    CLICKS,
    NET_REVENUE,
    RPM,
    RPMM,
    RPC,
    FOLLOWON_SEARCHES,
    INITIAL_SEARCHES,
    SEARCH_ENGINE,
    LINK_PLATFORM,
    TAG_TYPE,
    SERVER_SEARCHES_RPM,
    DIVIDED_PERCENTAGE,
    REMARKS,
    COUNTRY,
    MONETIZED_CTR,
    AD_COVERAGE_SERVER,
    QUALITY_SCORE,
    INVALID_TRAFFIC,
    SEARCH_COUNT,
    PUBLISHER_REVENUE_NEW,
    FILTERED_REASON,
    PUBLISHER_CHANNEL_ID,
    REDIRECT_FROM_PUBLISHER_CHANNEL_ID,
    PUBLISHER_ID,
    ADVERTISER_SEARCH_COUNT,
    OVERCAPPED_TRAFFIC,
    ADVERTISER_LINK_GROUP_ID,
    TRAFFIC_QUALITY,
    ADVERTISER_CHANNEL_ID,
    TRAFFIC_SOURCE,
    REVENUE_SHARE_PERCENTAGE
} from "./filters";

export const MAPPING_COLUMN_NAME = {
    date: DATE,
    subId: "channel",
    publisher: "publisher_id",
    rule_id: RULE_ID,
    tag_description: "tag_description",
    advertiser_id: ADVERTISER_REPORT,
    tag_number: "tag_number",
    geo: GEO,
    total_searches: TOTAL_SEARCHES,
    clicks: CLICKS,
    monetized_searches: MONETIZED_SEARCHES,
    gross_revenue: GROSS_REVENUE,
    net_revenue: NET_REVENUE,
    // ctr: CTR,
    rpm: RPM,
    rpmm: RPMM,
    rpc: RPC,
    monetized_ctr: MONETIZED_CTR,
    followon_searches: FOLLOWON_SEARCHES,
    initial_searches: "initial_searches",
    tq: TRAFFIC_QUALITY,
    // secondary_identifier: SECONDARY_IDENTIFIER,
};

export const mapping_order = [
    "date",
    "rule_id",
    "advertiser_id",
    "channel",
    "geo",
    "total_searches",
    "monetized_searches",
    "gross_revenue",
    "redirected_from_cid",
    "clicks",
    "monetized_ctr",
    "net_revenue",
    "rpm",
    "rpmm",
    "rpc",
    "followon_searches",
    "initial_searches",
    "tq",
    // "secondary_identifier"
];

export const csv_mapping_order = [
    "date",
    "channel",
    "geo",
    "total_searches",
    "monetized_searches",
    "clicks",
    "gross_revenue",
    "followon_searches",
    "initial_searches",
    "tq",
    // "secondary_identifier"
];

export const table_mapping_order = [
    DATE,
    TAG_ID,
    PUBLISHER_CHANNEL_ID,
    PUBLISHER_ID,
    REDIRECT_FROM_PUBLISHER_CHANNEL_ID,
    CHANNEL,
    ADVERTISER_CHANNEL_ID,
    SEARCH_ENGINE,
    TAG_TYPE,
    TRAFFIC_SOURCE,
    LINK_PLATFORM,
    RULE_ID,
    ADVERTISER_REPORT,
    ADVERTISER_LINK_GROUP_ID,
    QUALITY_SCORE,
    GEO,
    "server_search_counts",
    INVALID_TRAFFIC,
    OVERCAPPED_TRAFFIC,
    TOTAL_SEARCHES,
    MONETIZED_SEARCHES,
    CLICKS,
    // CTR,
    MONETIZED_CTR,
    AD_COVERAGE,
    GROSS_REVENUE,
    PUBLISHER_REVENUE,
    REVENUE_SHARE_PERCENTAGE,
    NET_REVENUE,
    RPM,
    RPMM,
    RPC,
    SERVER_SEARCHES_RPM,
    "ad_coverage_server_percentage",
    "discrepancy_percentage",
    TRAFFIC_QUALITY,
    DIVIDED_PERCENTAGE,
    REMARKS,
    "filtered",
    FILTERED_REASON
    // SECONDARY_IDENTIFIER
];

export const table_mapping_order_publisher = [
    DATE,
    TAG_ID,
    PUBLISHER_CHANNEL_ID,
    SEARCH_ENGINE,
    TAG_TYPE,
    LINK_PLATFORM,
    COUNTRY,
    SEARCH_COUNT,
    INVALID_TRAFFIC,
    TOTAL_SEARCHES,
    ADVERTISER_SEARCH_COUNT,
    MONETIZED_SEARCHES,
    CLICKS,
    MONETIZED_CTR,
    AD_COVERAGE,
    PUBLISHER_REVENUE_NEW,
    RPM,
    RPMM,
    RPC,
    "ssrpm",
    FOLLOWON_SEARCHES,
    INITIAL_SEARCHES,
    AD_COVERAGE_SERVER,
    FILTERED_REASON
];
